import Check from '@mui/icons-material/Check';
import InputAdornment from '@mui/material/InputAdornment';
import { BaseModal } from '@src/common/components/BaseModal';
import { Button } from '@src/common/components/button/Button';
import { Divider } from '@src/common/components/Divider';
import { Stack } from '@src/common/components/Stack';
import { TextInput } from '@src/common/components/TextInput';
import { theme } from '@src/common/styles/Theme';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onClose: () => void;
  open: boolean;
  onSubmit: (amount: string) => void;
}

export const FillAllServiceFeeModal = ({ onClose, open, onSubmit }: Props) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<string>('');
  return (
    <BaseModal
      title={t('fillAllServiceFeeModal.title')}
      subtitle={t('fillAllServiceFeeModal.subtitle')}
      open={open}
      onClose={onClose}
      marginBottom="0"
    >
      <TextInput
        style={{
          marginTop: theme.spacing['8'],
          marginBottom: theme.spacing['8'],
        }}
        type="number"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        label={t('fillAllServiceFeeModal.amount')}
        slotProps={{
          input: {
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          },
        }}
      />
      <Divider style={{ marginBottom: theme.spacing['9'] }} />
      <Stack direction="row" justifyContent="end" gap={theme.spacing['3']}>
        <Button type="button" variant="outlined" onClick={onClose}>
          {t('fillAllServiceFeeModal.cancel')}
        </Button>
        <Button
          type="button"
          variant="contained"
          startIcon={<Check />}
          onClick={() => {
            onSubmit(amount);
            setAmount('');
            onClose();
          }}
        >
          {t('fillAllServiceFeeModal.apply')}
        </Button>
      </Stack>
    </BaseModal>
  );
};
